<script>
import { reactive, onMounted, toRefs, watch, getCurrentInstance, ref } from '@vue/composition-api'
import { renderFun } from './business/renderForm'

// 所有可能用到的组件
import Editor from '@/components/Editor1/Editor.vue'
import CropperImg from './components/Cropper/'
import PreImg from '@/components/PreImg/'
import token from '@/composables/token'
import BetterScroll from 'better-scroll'
import AddTag from '@/components/Editor1/addTag'
import yzVideoUpload from '@/components/yzVideoUpload'

// 所有api列表数据请求
import initList from './composables/initList'
import uploadImg from './composables/uploadImg'
import { form, rules } from './business/constant'
// 所有依赖达到的枚举数据
import compuedFun from './computed/'
import api from '@/api/'

// 静态数据和方法
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

const title = {
  Add: '添加文章',
  Edit: '编辑文章'
}

function layout() {
  const list = this.renderFormList.map((o, idx) => {
    return (
      <a-col xs={24} sm={12} md={8} lg={8} xl={8}>
        {renderFun[o.field_type].call(this, o)}
      </a-col>
    )
  })
  return list
}

export default {
  components: {
    PreImg,
    Editor,
    AddTag,
    CropperImg,
    yzVideoUpload
  },
  setup() {
    const _this = getCurrentInstance()

    // computed
    const templateId = _this.$route.params.id
    const id = _this.$route.query.id
    const type = _this.$route.query.type
    const line_id = _this.$route.query.line_id

    const state = reactive({
      line_id: _this.$route.query.line_id,
      title: title.Add,
      renderFormList: [], // 渲染表单列表（发布平台）
      articleFormList: [], // 渲染表单列表（文章内容）
      line_idPlatformList: [], // 业务线列表
      form: { ...form, qi_niu_domains: 'http://qiniu.yuzhua.info' }, // 表单对象（用于存储表单数据）
      rules: {}, // 验证规则
      titleHtml: '',
      contentHtml: '',
      isPcShow: false, // 是否是pc预览
      isAppShow: false, // 是否是移动预览
      appDetailUrl: '', // app 地址
      labelSearchValue: undefined,
      labelList: [], // 标签列表
      timer: null,
      // 常量
      token: storage.get(ACCESS_TOKEN),
      baseURL: process.env.VUE_APP_API_BASE_URL,
      previewPc: false,
      previewMobile: false,
      module: 1,
      tagId: id,
      tagList: [],
      hasKeyword: false,
      hasLabel: false,
      hasChoosedLabel: [],
      platformList: []
    })

    watch(
      () => state.form.title,
      () => {
        if (state.form.title === '') {
          _this.titleHtml = ''
        }
      }
    )
    watch(
      () => state.form.content,
      () => {
        if (state.form.content === '') {
          _this.contentHtml = ''
        }
      }
    )

    onMounted(async () => {
      await methods.getTemForm()
      methods.createFiled()
      // 如果是新增 添加随机阅读
      if (!id) {
        methods.getPlatformList(state.line_id)
        _this.$set(state.form, 'is_rand', 0)
        _this.$set(_this.rules, 'is_rand', [{ required: true, message: '请选择是否随机阅读数', trigger: 'change' }])
        _this.$set(state.form, 'line_id', state.line_id)
        _this.$set(_this.rules, 'line_id', [{ required: true, message: '请选择业务线', trigger: 'change' }])
      }
      // 注入业务线id和模板
      state.form.line_id = Number(line_id)
      state.form.template_id = Number(templateId)

      if (id) {
        _this.title = title.Edit
        methods.getArticleDetail()
      }
    })
    const tagVisible = ref(null)
    const methods = {
      // 获取新增标签
      async getLable(data) {
        await _this.getLabel({ label_name: data.label_name })
        state.form.label_ids.push(data.id)
        _this.$refs.formDom.validateField('label_ids', async valid => {})
      },
      // 显示新增标签表单
      handleAddTag() {
        tagVisible.value.changeV()
      },
      changePlatform(e) {
        this.labelList = []
      },
      // 获取平台列表
      async getPlatformList(line_id) {
        const res = await api.LineListNew()
        const options = res.data
        state.platformList = res.data.filter(item => {
          if (item.parent_id === 0) {
            return item
          }
        })
        const b = options.find(item => item.id === Number(line_id))
        state.line_idPlatformList.push(b)
        _this.getDepartment(options, parseInt(b?.id))
        state.line_idPlatformList = state.line_idPlatformList.length > 0 ? state.line_idPlatformList : state.platformList
      },
      // 过滤平台列表
      getDepartment(options, line_id) {
        options.map(item => {
          if (item.parent_id === line_id) {
            state.line_idPlatformList.push(item)
            _this.getDepartment(options, parseInt(item.id))
          }
        })
      },
      // 启动滚动
        startScroll(dom) {
        const wap = _this.$refs.wap
        _this.$nextTick(() => {
          new BetterScroll('.' + dom, {})
        })
      },
      previewPcFn() {
        // state.previewPc = true
        // methods.startScroll('pc-container')
        _this.isPcShow = true
        _this.handleSubmit()
      },
      previewWapFn() {
        // state.previewMobile = true
        // methods.startScroll('wap-container')
        _this.isAppShow = true
        _this.handleSubmit()
      },
      back() {
        this.$router.push('/article/list')
      },
      // 生辰表单字段
      createFiled() {
        _this.renderFormList.forEach(o => {
          if (o.field_type === 'select') {
            _this.$set(state.form, o.field, undefined)
          } else if (o.field_type === 'selectMult') {
            _this.$set(state.form, o.field, [])
          } else if (o.field_type === 'radio') {
            _this.$set(state.form, o.field, 0)
          } else {
            _this.$set(state.form, o.field, '')
          }
          methods.createdRules(o)
        })
        _this.articleFormList.forEach(o => {
          if (o.field_type === 'select') {
            _this.$set(state.form, o.field, undefined)
          } else if (o.field_type === 'selectMult') {
            _this.$set(state.form, o.field, [])
          } else if (o.field_type === 'radio') {
            _this.$set(state.form, o.field, 0)
          } else {
            _this.$set(state.form, o.field, '')
          }
          methods.createdRules(o)
        })
      },
      // 生成验证规则
      createdRules(data) {
        data.must === 1 &&
          _this.$set(_this.rules, data.field, [{ required: true, message: this.showTips(data), trigger: 'change' }])
      },
      async getArticleDetail() {
        const res = await api.detailArticle({ id: id })
        const data = res.data.article
        state.form = data
        state.form.publisher_id = Number(state.form?.publisher_id) || undefined
        _this.labelList = res.data.article.label.map(item => ({ ...item, id: Number(item.id) }))
        _this.handleEchoImg(state.form)
        // if (state.hasKeyword && state.hasLabel && state.form.keywords) {
        //   _this.getTags()
        // }
        // 获取推荐标签列表
        if (state.form.keywords) {
          await _this.getTags()
          // 被选中的推荐标签
          _this.tagList.forEach(tag => {
            if (state.form.label_ids.includes(Number(tag.id))) {
              tag.checked = true
            }
          })
        }
      },
      // 根据关键词搜索标签
      async getTags() {
        if (!state.form.keywords) return _this.$message.warning('请先填写关键词')
        const { data } = await api.labelSearch({
          status: 1,
          line_id: state.form.line_id,
          is_no_business_child: 1, // 是否不包含子类目数据 默人包含  传1不包含
          label_name: state.form.keywords,
          page: 1,
          per_page: 510
        })
        const resData = data ? data.label || [] : []
        if (!resData.length) this.$message.warning('没有相关数据')
        _this.tagList = resData.map(item => {
          item.checked = false
          return item
        })
      },
      // 选中或者取消标签
      async chooseOneTag(tag, checked) {
        await _this.getLabel({ label_name: tag.label_name })
        const tagId = this.labelList[0]?.id
        if (checked) { // 选中
          if (tagId && !this.form.label_ids.includes(tagId)) {
            this.form.label_ids = [...this.form.label_ids, tagId]
          }
        } else { // 取消
          this.form.label_ids = this.form.label_ids.filter(item => String(item) !== String(tagId))
        }
      },

      showTips(data) {
        if (data.field_tip) {
          return data.field_tip
        } else if (['selectMult', 'select', 'radio'].includes(data.field_type)) {
          return '请选择'
        } else if (['input', 'textarea', 'editor'].includes(data.field_type)) {
          return '请输入'
        } else if (['upload'].includes(data.field_type)) {
          return '请上传图片'
        } else if (['cutPre'].includes(data.field_type)) {
          return '请裁剪图片'
        } else if (['videoUpload'].includes(data.field_type)) {
          return '请上传视频'
        }
      },
            // 获取表单模板
      async getTemForm() {
        const res = await api.detailTemplate({ id: templateId })
        if (_this.$validate(res)) {
          // 对表单进行排序
          // state.renderFormList = res.data.template.templateField
          res.data.template.templateField.map((item) => {
            if (
              item.field === 'typeid' ||
              item.field === 'label_ids' ||
              item.field === 'publisher_id' ||
              item.field === 'istop' ||
              item.field === 'iscommend'
            ) {
              state.renderFormList.push(item)
            } else {
              state.articleFormList.push(item)
            }
            // 如果存在关键词和文章标签 则 显示推荐标签
            if (item.field === 'keywords') {
              state.hasKeyword = true
            }
            if (item.field === 'label_ids') state.hasLabel = true
          })
          if (state.hasKeyword && state.hasLabel) {
            let keywordsIndex
            state.articleFormList.find((item, idx) => {
              if (item.field === 'keywords') {
                keywordsIndex = idx
              }
            })
            const splicedArrFirst = state.articleFormList.slice(0, keywordsIndex + 1)
            const splicedArrLast = state.articleFormList.slice(keywordsIndex + 1)
            const recommended = {
              field: "recommended_tag",
              field_name: "推荐标签",
              field_remark: "",
              field_tip: "",
              field_type: "input",
              label: "",
              must: 0,
              sort: 0,
              // template_id: 33,
            }
            state.articleFormList = [...splicedArrFirst, recommended, ...splicedArrLast]
          }
        }
      },
      // 违禁词
      async forbiddenWords(type) {
        if (type === 'title') {
          if (!state.form.title) return _this.$message.warning('内容为空')
          const res = await api.forbiddenWordsArticle({ content: state.form.title, module: 1 })
          if (_this.$validate(res)) {
            if (/#F00/g.test(res.data.content)) {
              _this.$message.warning('存在为违禁词')
              _this.titleHtml = res.data.content
            } else {
              _this.titleHtml = ''
            }
          }
        }
        if (type === 'content') {
          if (!state.form.content) return _this.$message.warning('内容为空')
          const res = await api.forbiddenWordsArticle({ content: state.form.content, module: 1 })
          if (_this.$validate(res)) {
            if (/#F00/g.test(res.data.content)) {
              _this.$message.warning('存在为违禁词')
              _this.contentHtml = res.data.content
            } else {
              _this.contentHtml = ''
            }
          }
        }
      },
      async submit() {
        let res = null
        if (type === '1') {
          if (id) {
            state.form.publisher_id = state.form.publisher_id || 0
            const data = JSON.parse(JSON.stringify(state.form))
            data.label_ids = data.label_ids && data.label_ids.join(',')
            res = await api.updateArticle(data)
          } else {
            state.form.publisher_id = state.form.publisher_id || 0
            const data = JSON.parse(JSON.stringify(state.form))
            data.label_ids = data.label_ids && data.label_ids.join(',')
            res = await api.createArticle(data)
          }
        } else {
          if (id) {
            res = await api.updateInterview(state.form)
          } else {
            res = await api.createInterview(state.form)
          }
        }
        if (_this.$validate(res)) {
          // pc 预览
          if (res.data.data.pc_detail_url && _this.isPcShow) {
            window.open(res.data.data.pc_detail_url)
          }
          if (_this.isPcShow && !res.data.data.pc_detail_url) {
            state.previewPc = true
            methods.startScroll('pc-container')
          }
          if (_this.title === '添加文章' && _this.isPcShow) {
            const { template_id, id, line_id } = res.data
            this.$router.push(`/article/template/${template_id}?id=${id}&line_id=${line_id}&type=1`)
            this.$router.go(0)
          }
          // 移动预览
          if (_this.isAppShow && res.data.data.app_detail_url) {
            state.previewMobile = true
            methods.startScroll('wap-container')
            this.appDetailUrl = res.data.data.app_detail_url
          } else {
            this.appDetailUrl = ''
          }
          _this.getRouterUrl(_this.isPcShow, _this.isAppShow)
          _this.isPcShow = false
          _this.isAppShow = false
        }
      },
      getRouterUrl(pcShow = false, appShow = false) {
        const list = []
        list.push(pcShow, appShow)
        if (list.indexOf(true) === -1) {
          this.$message.success(id ? '编辑成功~' : '添加成功~')
          this.$router.push('/article/list')
        }
      },

      async handleSubmit() {
        _this.$refs.formDom.validate(async valid => {
          if (valid) {
            // if (!state.form.title || !state.form.content) {
            //   return this.$message.warning('文章标题与文章内容是必须填写的哦～')
            // }
            const arr = await Promise.all([
              api.forbiddenWordsArticle({ content: state.form.title, module: 1 }),
              api.forbiddenWordsArticle({ content: state.form.content, module: 1 })
            ])
            if (/#F00/g.test(arr[0].data.content) || /#F00/g.test(arr[1].data.content)) {
              _this.$confirm({
                content: '存在为违禁词,请确认是否提交？',
                async onOk() {
                  _this.submit()
                }
              })
            } else {
              _this.submit()
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
          }
        })
      },
      // 获取标签
      async getLabel(data = {}) {
        data = Object.assign({}, data, {
          status: 1,
          line_id: this.form.line_id ? this.form.line_id : state.line_id,
          page: 1,
          per_page: 100
        })
        const res = await api.labelSearch(data)
        this.labelList = res.data.label
      },
      pcCancel() {
        state.previewPc = false
      },
      wapCancel() {
        state.previewMobile = false
      },
      handleLabelsSelectSearch(value) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          this.getLabel({ label_name: value })
        }, 500)
      },
      handleLabelsSelectChange(value) {
        this.form.label_ids = value
      }
    }
    return {
      ...toRefs(state),
      ...compuedFun(),
      ...initList(),
      ...uploadImg(),
      ...token(),
      tagVisible,
      ...methods
    }
  },
  render() {
    return (
      <a-card title={this.title}>
        <a-form-model
          ref="formDom"
          attrs={{ rules: this.rules, model: this.form }}
          label-col={{ span: 6 }}
          wrapper-col={{ span: 16 }}
          labelAlign={'left'}
        >
          <a-divider orientation="left">发布平台</a-divider>
          <a-row>
            {!this.$route.query.id ? (
              <a-col span="10">
                <a-form-model-item label="选择业务线" prop="line_id">
                  <a-select
                    vModel={this.form.line_id}
                    allowClear
                    show-search
                    option-filter-prop="children"
                    placeholder="请选择"
                    onChange={this.changePlatform}
                  >
                    {this.line_idPlatformList.map(item => (
                      <a-select-option key={item.id} value={item.id}>
                        {' '}
                        {item.org}{' '}
                      </a-select-option>
                    ))}
                  </a-select>
                </a-form-model-item>
              </a-col>
            ) : (
              ''
            )}
            <a-col>
              {this.renderFormList.map((o, idx) => {
                if (o.field === 'typeid' || o.field === 'publisher_id') {
                  return renderFun.select.call(this, o)
                }
              })}
            </a-col>
          </a-row>
          <a-row>
            {this.renderFormList.map((o, idx) => {
              if (o.field === 'label_ids') {
                return renderFun.selectSearch.call(this, o)
              }
            })}
            {this.renderFormList.map((o, idx) =>
              o.field === 'label_ids' ? (
                <a-button v-show={!this.tagId} type="primary" style="margin-top:2px;" onClick={this.handleAddTag}>
                  新增标签
                </a-button>
              ) : (
                ''
              )
            )}
          </a-row>
          <a-row>
            {!this.$route.query.id ? (
              <a-col span="8">
                <a-form-model-item label="随机阅读数" prop="is_rand">
                  <a-radio-group vModel={this.form.is_rand}>
                    <a-radio value={0}>否</a-radio>
                    <a-radio value={1}>是</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            ) : (
              ''
            )}
            {this.renderFormList.map((o, idx) => {
              if (o.field === 'istop' || o.field === 'iscommend') {
                return renderFun[o.field_type].call(this, o)
              }
            })}
          </a-row>
          <a-divider orientation="left">文章内容</a-divider>
          <a-row>
            {this.articleFormList.map((o, idx) => {
              if (
                o.field === 'author' ||
                o.field === 'description' ||
                o.field === 'title' ||
                o.field === 'keywords' ||
                o.field === 'comment' ||
                o.field === 'created_month' ||
                o.field === 'title2' ||
                o.field === 'recommended_tag'
              ) {
                return renderFun.input.call(this, o)
              }
            })}
          </a-row>
          <a-row>
            {this.articleFormList.map((o, idx) => {
              if (
                o.field === 'author' ||
                o.field === 'description' ||
                o.field === 'title' ||
                o.field === 'keywords' ||
                o.field === 'comment' ||
                o.field === 'created_month' ||
                o.field === 'title2' ||
                o.field === 'recommended_tag'
              ) {
              } else {
                return renderFun[o.field_type] && renderFun[o.field_type].call(this, o)
              }
            })}
          </a-row>
          <a-row>
            <a-col span="16">
              <a-form-model-item wrapper-col={{ span: 20, offset: 1 }}>
                <a-button class="mr20" type="primary" onClick={this.handleSubmit}>
                  {this.$route.query.status === '2' ? '提交审核' : '保 存'}
                </a-button>
                <a-button onClick={this.back}>取 消</a-button>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
        <a-modal visible={this.previewVisible} footer={null} onCancel={this.handleCancle}>
          <img alt="example" style="width: 100%" src={this.previewImage} />
        </a-modal>

        <a-modal
          width="50%"
          title="图片裁剪"
          destroyOnClose={true}
          visible={this.cropperVisible}
          footer={null}
          onCancel={this.handleCut}
        >
          <CropperImg init-img={this.tailorImg} onHandleTailorOver={this.handleTailorOver} />
        </a-modal>

        <a-modal
          attrs={{ width: 1200, destroyOnClose: true, visible: this.previewPc, footer: null }}
          onCancel={this.pcCancel}
        >
          <div class="pc-container">
            <div domPropsInnerHTML={this.form.content}></div>
          </div>
        </a-modal>

        <a-modal
          attrs={{ width: 423, destroyOnClose: true, visible: this.previewMobile, footer: null }}
          onCancel={this.wapCancel}
        >
          <div class="wap-container" style={this.appDetailUrl === '' ? 'display: none' : 'display: block;'}>
            <iframe src={this.appDetailUrl} style="width: 100%;height: 100%;"></iframe>
          </div>
          <div class="wap-container" style={this.appDetailUrl === '' ? 'display: block;' : 'display: none'}>
            <div class="preViewWap" domPropsInnerHTML={this.form.content}></div>
          </div>
        </a-modal>
        <AddTag ref="tagVisible" ongetLable={this.getLable} />
      </a-card>
    )
  }
}
</script>
<style lang="less" scoped>
.img-default {
  width: 100px;
  height: 100px;
  background-color: #f5f7fa;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pc-container {
  width: 100%;
  height: 700px;
  overflow-y: auto;
  /deep/img {
    width: 100%;
    height: auto;
  }
}
.wap-container {
  width: 375px;
  height: 667px;
  overflow-y: auto;
}
.preViewWap {
  /deep/img {
    width: 100%;
    height: auto;
  }
}
.tags-swapper{
  max-height: 200px;
  min-height: 40px;
  overflow-y: auto;
  border: 2px solid #eee;
  padding: 3px 5px;
  border-radius: 5px;
  /deep/.ant-tag{
    margin-right: 5px !important;
    border: 1px solid #d9d9d9;
  }
}
</style>

<style lang="less">
.ant-form-item label {
  white-space: normal !important;
}
</style>
